import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEndUserStore } from '@store/enduser';

export const useTabNavigationGuard = (
	requiredStep: number,
	redirectTo = '/lms/add-new-site/site-information'
): void => {
	const navigate = useNavigate();
	const activeTabIndex = useEndUserStore((state) => state.activeTabIndex);

	useEffect(() => {
		if (activeTabIndex < requiredStep) {
			navigate(redirectTo, { replace: true });
		}
	}, [activeTabIndex, navigate, requiredStep, redirectTo]);
};
